export default __webpack_public_path__ + "static/media/roborovski@2x.87c01a45.png";